jQuery(function ($) {

    // ===========================
    // スマホメニューの切り替え
    // ===========================
    var gnavWrapperClass = $('.js-gnav'); // ナビゲーション全体を囲んでいるクラス名
    var gnavToggleClass = $('.js-gnav-toggle'); // トグルメニューのクラス名
    var gnavNavClass = $('.js-gnav-nav'); // ナビバーを囲んでいるクラス名
    var activeClass = 'is-active'; // アクティブ時のクラス名

    function SPmenuOpen() {
        gnavWrapperClass.toggleClass(activeClass);

        if (gnavWrapperClass.hasClass(activeClass)) {
            gnavToggleClass.addClass(activeClass);
            gnavNavClass.addClass(activeClass);
        } else {
            gnavToggleClass.removeClass(activeClass);
            gnavNavClass.removeClass(activeClass);
        }
    }

    function SPmenuClose() {
        gnavWrapperClass.removeClass(activeClass);
        gnavToggleClass.removeClass(activeClass);
        gnavNavClass.removeClass(activeClass);
    }

    // トグルクリックで開閉
    $('.js-gnav-toggle, .l-header-nav--sp__close').on('click', function () {
        SPmenuOpen();
    });

    // ナビ以外をクリックしたら閉じる
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.js-gnav-navbar').length && gnavWrapperClass.hasClass(activeClass)) {
            SPmenuOpen();
        }
    });

    // メニュー内リンククリックで閉じる（指定されたキャンペーンヘッダー内）
    $('.l-header--campaign-2025 .l-header-nav nav ul li a').on('click', function () {
        if (gnavWrapperClass.hasClass(activeClass)) {
            SPmenuClose();
        }
    });

    // ===========================
    // PCメニューのサブメニュー制御
    // ===========================
    var gnavMenuClass = $('.js-gnav-menu--pc'); // メニューのクラス
    var gnavHasSubmenuClass = '.menu-item-has-children'; // サブメニューを持っている親クラス

    if (window.matchMedia('(min-width: 1200px)').matches) {
        // hover状態の制御
        gnavMenuClass.find(gnavHasSubmenuClass).on('mouseenter', function () {
            $(this).addClass(activeClass);
        }).on('mouseleave', function () {
            $(this).removeClass(activeClass);
        });
    }

});
